module.exports = new __parcel__URL__("shop_item_info_divider_long.350cf459.png").toString();